import React from 'react';
import VideoJS from './VideoJS';
import { useSettings } from '../../context/Settings';
import { getCountryName } from '../../i18n/i18n';

interface VideoPlayerProps {
  accountId: string;
  videoId: string;
  videoUrl: string;
  loop?: boolean;
  onEnded?: () => void;
  onCanPlay?: () => void;
  unmuted?: boolean;
  onPlayerReady?: (player: any) => void;
}

export const VideoPlayer: React.FunctionComponent<VideoPlayerProps> = ({
  videoId,
  videoUrl,
  loop,
  onEnded,
  onCanPlay,
  unmuted,
  onPlayerReady,
}) => {
  const playerRef = React.useRef(null);

  const { settings } = useSettings();
  const language = settings.language;

  const videoJsOptions = {
    autoplay: true,
    playsinline: true,
    controls: true,
    responsive: true,
    fluid: true,
    loop: loop,
    muted: !unmuted,
    subtitles: true,
    sources: [
      {
        src: videoUrl,
        type: 'video/mp4',
      },
    ],
    tracks: [
      {
        kind: 'captions',
        src: `/subtitles/${language}/${videoId}.vtt`,
        srclang: language,
        label: getCountryName(language || 'en'),
      },
    ],
  };

  const handlePlayerReady = (player: any) => {
    playerRef.current = player;

    const settings = player.textTrackSettings;
    settings.setValues({
      backgroundColor: '#000',
      backgroundOpacity: '0',
    });
    settings.updateDisplay();

    if (onEnded) player.on('ended', onEnded);
    if (onCanPlay)
      player.on('canplay', () => {
        onCanPlay();

        var tracks = player.textTracks();
        for (var i = 0; i < tracks.length; i++) {
          var track = tracks[i];
          if (track.kind === 'captions' || track.kind === 'subtitles') {
            // Only show subtitles if the video is unmuted
            track.mode = unmuted ? 'showing' : 'hidden';
          }
        }
      });
    
    // Call the onPlayerReady callback to expose the player instance
    if (onPlayerReady) onPlayerReady(player);
  };

  return <VideoJS options={videoJsOptions} onReady={handlePlayerReady} />;
};
